/* eslint-disable no-console */

//versão 1.20

import { register } from "register-service-worker";

if (process.env.NODE_ENV === "production") {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        "App is being served from cache by a service worker.\n" +
          "For more details, visit https://goo.gl/AFskqB"
      );
    },
    registered() {
      console.log("Service worker has been registered.");
    },
    cached() {
      console.log("Content has been cached for offline use.");
    },
    updatefound() {
      console.log("New content is downloading.");
    },
    updated() {
      console.log("New content is available; please refresh.");
      showUpdateNotification();
    },
    offline() {
      console.log(
        "No internet connection found. App is running in offline mode."
      );
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    },
  });
}

function showUpdateNotification() {
  const updateNotification = document.createElement("div");
  updateNotification.innerHTML = `
  <div class="update-notification">
    <div class="update-content">
      <p>Uma nova atualização está disponível!</p>
      <button id="refresh">Atualizar Agora</button>
    </div>
    <div class="update-close" id="close-update-notification">&times;</div>
  </div>
`;
  document.body.appendChild(updateNotification);

  document.getElementById("refresh").addEventListener("click", function () {
    if (navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({ action: "skipWaiting" });
    }
    window.location.reload();
  });

  document
    .getElementById("close-update-notification")
    .addEventListener("click", function () {
      document.querySelector(".update-notification").style.display = "none";
    });
}
